import styled, { css } from 'styled-components';
import { FormField, FormFieldHeader, FormFieldProps } from 'ui/formField';
import { spacing } from 'ui/theme';

type CampaignFormFieldProps = FormFieldProps & { $removeMarginBottom?: boolean };

/**
 * WARNING: the `FormField` component doesn't work with `string` direct children (09/06/2022)
 * @example
 * ```jsx
 * <CampaignFormField>This won't display </CampaignFormField>
 * ```
 * @see src/ui/formField/FormField.tsx
 */
export const CampaignFormField = styled(FormField)<CampaignFormFieldProps>`
  width: 100%;
  display: flex;
  align-items: flex-start;
  & + & {
    margin-bottom: 0;
  }
  ${FormFieldHeader} {
    min-width: ${spacing.x8};
    max-width: ${spacing.x8};
    margin: 0 ${spacing.x3} ${spacing.half} 0;
  }
  ${({ $removeMarginBottom }) =>
    $removeMarginBottom
      ? ''
      : css`
          margin-bottom: ${spacing.double};
        `}
`;

/**
 * Since the campaign editor fields are generally rendered with the `isHorizontalLayout`,
 * we are setting it as default here.
 */
CampaignFormField.defaultProps = { isHorizontalLayout: true };
